import { IconButton, DialogTitle as MuiDialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export type DialogTitleProps = {
  title: React.ReactNode;
  handleClose?: () => void;
};
export const DialogTitle = ({ title, handleClose }: DialogTitleProps) => {
  return (
    <MuiDialogTitle sx={{ position: "relative" }}>
      {title}
      {typeof handleClose === "function" && (
        <IconButton onClick={handleClose} sx={{ position: "absolute", right: "0", top: 0 }}>
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};
export default DialogTitle;
